export default __webpack_public_path__ + "static/NationalSPA-c4a86b10761e54a2dd835519b48ff479.pdf";